import styled from 'styled-components';
import { rem } from 'polished';
import { ModalDemoVehicleInfoStyled } from '../ModalDemoVehicleInfoStyled';

export const ModalDemoVehicleInfoStyledAC = styled(ModalDemoVehicleInfoStyled)``;
